import * as z from "zod";
import { baseCustomerEventSchema, CustomerEventType } from "./base";

export interface RawCoverageInfoModalOpenedEvent {
  eventType: CustomerEventType.COVERAGE_INFO_MODAL_OPENED;
  anonymousId: string;
  treatmentId?: string;
  eventId: string;
}

export const CoverageInfoModalOpenedShoppingEventSchema_ =
  baseCustomerEventSchema.extend({
    eventType: z.literal(CustomerEventType.COVERAGE_INFO_MODAL_OPENED),
    anonymousId: z.string(),
    treatmentId: z.string().optional(),
    eventId: z.string(),
  });
